export enum SlidesActions {
  SetSmPositions = 'setSlidesPositions',
  SetMlPositions = 'setMlPosition',
  SetSleftPosition = 'setSLeftPosition',
  SetLRightPosition = 'setLRightPosition',
}
